import { render, staticRenderFns } from "./bulma_fieldset_IS.vue?vue&type=template&id=59a71d50&scoped=true&lang=html"
import script from "./bulma_fieldset_IS.vue?vue&type=script&lang=js"
export * from "./bulma_fieldset_IS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a71d50",
  null
  
)

export default component.exports